import axios from 'axios';
import QS from 'qs';
import {MessageBox, Message, Loading} from 'element-ui';
import router from '../router'
import VueCookies from 'vue-cookies'

let loading;

axios.defaults.timeout = 100000; // 响应时间
axios.defaults.headers.post[ 'Content-Type' ] = 'application/json;charset=UTF-8';
axios.defaults.headers.put[ 'Content-Type' ] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true; // 携带cookie

//请求拦截器
axios.interceptors.request.use(
	config => {
		// loading遮罩
		loading = Loading.service({
			lock: true, // 是否锁屏
			text: '拼命加载中', // 加载动画的文字
			spinner: 'el-icon-loading', // 引入的loading图标
			background: 'rgba(0, 0, 0, 0.3)', // 背景颜色
			customClass: 'myLoading', // 遮罩层新增类名
			body: true,
		});
		return config;
	},
	error => {
		return Promise.error(error);
	}
)

// 响应拦截器
axios.interceptors.response.use(
	response => {
		loading.close();
		if (response.status === 200) {
			if (response.data.code === 401) {
				VueCookies.remove('current_system_token');
				MessageBox.alert('登录信息超时，请重新登录！', '登录超时', {
				  confirmButtonText: '去登录',
				  callback: action => {
				    router.push('/');
				  }
				});
			} else {
				return Promise.resolve(response);
			}
		} else {
			Promise.reject(response);
		}
	},
	error => {
		loading.close();
		return Promise.reject(error.response);
	}
);

const request = {
	/**
	 * post请求
	 * @param {String} url [请求的url地址]
	 * @param {Object} params   [参数列表]
	 */
	post: (url, params) => {
		return new Promise((resolve, reject) => {
			axios.post(url, params)
			.then(res => {
				if (res) {
					if (res.data.code === 200) { //正常
						resolve(res.data.data);
					} else { // 出错
						Message({
							message: res.data.message,
							type: 'warning'
						});
					}
				}
			})
			.catch(err => {
				Message({
					message: '系统异常',
					type: 'error'
				});
			})
		})
	},
	
	/**
	 * get请求
	 * @param {String} url [请求的url地址]
	 * @param {Object}  params [参数]
	 */
	get: (url, params) => {
		return new Promise((resolve, reject) => {
			axios.get(url, {
				params: params
			})
			.then(res => {
				if (res.data.code === 200) { // 成功
					resolve(res.data.data);
				} else {
					Message({
						message: res.data.message,
						type: 'warning'
					});
				}
			})
			.catch(err => {
				Message({
					message: '系统异常',
					type: 'error'
				})
			})
		})
	},
	
	/**
	 * delete请求
	 * @param {String}  url [接口地址]
	 * @param {Object}  params [参数]
	 */
	delete: (url, params) => {
		return new Promise((resolve, reject) => {
			axios.delete(url, {
				params: params
			})
			.then(res => {
				if(res.data.code === 200) { // 成功
					resolve(res.data.data);
				} else {
					Message({
						message: res.data.message,
						type: 'warning'
					});
				}
			})
			.catch(err => {
				Message({
					message: '系统异常',
					type: 'error'
				})
			})
		})
	},
	
	/**
	 * put操作
	 */
	put: (url, params) => {
		return new Promise((resolve, reject) => {
			axios.put(url, params)
			.then(res => {
				if (res.data.code === 200) { // 成功
					resolve(res.data.data);
				} else {
					Message({
						message: res.data.message,
						type: 'warning'
					});
				}
			})
			.catch(err => {
				Message({
					message: '系统异常',
					type: 'error'
				})
			})
		})
	},
}

export default request;